import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import delve from 'dlv'

import App from '../core'
import BuyflowContainer from './BetterBuyflow/BuyflowContainer'
import Loading from '../Loading/Loading'
import buyflowPlugin from '../schemaPlugins'
import { SchemaConsumer, SchemaProvider } from '../contexts/SchemaContext'
import MuiBuyflow from './BetterBuyflow/MuiBuyflow'
import Relay from './Relay'

const SchemaBuyflow = ({ isAdmin }) => (
  <SchemaProvider isAdmin={isAdmin}>
    <SchemaConsumer>
      {context => {
        if (context.loading) {
          return (
            <BuyflowContainer>
              <Loading pastDelay forceShow>
                Almost ready
              </Loading>
            </BuyflowContainer>
          )
        }
        if (context.error) {
          const error = delve(context, 'error.message', '')
          const message = `Failed to load the schema! ${error}`.trim()
          return (
            <BuyflowContainer>
              <div className="alert--error">
                <svg className="icon cell-align--center">
                  <use xlinkHref="#close" />
                </svg>
                {message}
              </div>
            </BuyflowContainer>
          )
        }
        const formName = context.schema.form || 'buyflow'
        return (
          <App
            waitUntilReady
            plugins={{ [formName]: buyflowPlugin }}
            storageKey={formName}
            storageWhitelist={[]
              .concat(context.schema.storage)
              .filter(v => !!v)
              .map(v => ['form', formName, 'values', v])}>
            <Relay>
              {({ store }) => (
                <Switch>
                  <Route
                    path="/buyflow/schema"
                    render={() => (
                      <SchemaConsumer>
                        {context => (
                          <MuiBuyflow
                            store={store}
                            schema={context.schema}
                            isAdmin={isAdmin}
                          />
                        )}
                      </SchemaConsumer>
                    )}
                  />
                  <Redirect to="/buyflow/schema" />
                </Switch>
              )}
            </Relay>
          </App>
        )
      }}
    </SchemaConsumer>
  </SchemaProvider>
)

export default SchemaBuyflow
